import { api } from '../lib/api';
import type { ContactGroup } from '../types';

function parseContactGroup(raw: any): ContactGroup {
  return {
    id: raw.id,
    name: raw.name ?? '',
    description: raw.description ?? '',
    contactIds: raw.contactIds ?? [],
    memberCount: raw.memberCount ?? raw.contactIds?.length ?? 0,
    createdAt: new Date(raw.createdAt ?? raw.created_at),
    updatedAt: new Date(raw.updatedAt ?? raw.updated_at),
  };
}

export async function listContactGroups(): Promise<ContactGroup[]> {
  const results = await api<any[]>('/api/contact-groups');
  return results.map(parseContactGroup);
}

export async function getContactGroup(id: string): Promise<ContactGroup> {
  const raw = await api<any>(`/api/contact-groups/${id}`);
  return parseContactGroup(raw);
}

export async function createContactGroup(data: {
  name: string;
  description?: string;
}): Promise<{ id: string }> {
  return api<{ id: string }>('/api/contact-groups', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateContactGroup(
  id: string,
  data: { name?: string; description?: string; contactIds?: string[] },
): Promise<void> {
  await api(`/api/contact-groups/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteContactGroup(id: string): Promise<void> {
  await api(`/api/contact-groups/${id}`, { method: 'DELETE' });
}

export async function addContactsToGroup(groupId: string, contactIds: string[]): Promise<void> {
  await api(`/api/contact-groups/${groupId}/contacts`, {
    method: 'POST',
    body: JSON.stringify({ contactIds }),
  });
}

export async function removeContactFromGroup(groupId: string, contactId: string): Promise<void> {
  await api(`/api/contact-groups/${groupId}/contacts/${contactId}`, {
    method: 'DELETE',
  });
}
